import { gql } from "@apollo/client";

export const GET_LABOR_ISSUE_MENU = gql`
  query laborIssuePrograms($limit: Int, $sort: String) {
    laborIssuePrograms(limit: $limit, sort: $sort) {
      id
      title
      description
      feat_img {
        url
      }
      labor_issue_files {
        id
        title
        file {
          id
          name
          mime
          url
        }
      }
      labor_issue_images {
        id
        title
        images {
          url
        }
      }

      labor_issue_videos {
        id
        title
        video_url
        created_date
      }
    }
  }
`;

export const GET_LABOR_ISSUE_PROGRAM = gql`
  query laborIssueProgram($id: ID!) {
    laborIssueProgram(id: $id) {
      id
      title
      description
      feat_img {
        url
      }
      labor_issue_files {
        id
        title
        file {
          id
          name
          mime
          url
        }
      }
      labor_issue_images {
        id
        title
        images {
          url
        }
      }

      labor_issue_videos {
        id
        title
        video_url
        created_date
      }
    }
  }
`;
